export default __webpack_public_path__ + "static/media/IRANSansWeb_Bold.dd12fb6a.woff";